import { useEffect, type JSX } from 'react';
import { useChatThinkingIndicatorViewModel } from './chat-thinking-indicator.viewmodel';

type Props = {
  /** Up to 4 messages cycled through on a timed schedule. */
  messages?: string[];
};

const DEFAULT_MESSAGES = ['Even denken...', 'Gegevens ophalen...', 'Bijna klaar...', 'Nog even geduld...'];

export const ChatThinkingIndicator = ({ messages = DEFAULT_MESSAGES }: Props): JSX.Element => {
  const [state, viewModel] = useChatThinkingIndicatorViewModel(messages.length);

  useEffect(() => {
    viewModel.start();
    return () => viewModel.stop();
  }, [viewModel]);

  return (
    <div className='chatbot-thinking'>
      <span className='chatbot-thinking-message'>{messages[state.messageIndex]}</span>
      <div className='chatbot-thinking-dots'>
        <div className='chatbot-thinking-dot' />
        <div className='chatbot-thinking-dot' />
        <div className='chatbot-thinking-dot' />
      </div>
    </div>
  );
};
